import { Dispatch, connect } from 'react-redux';
import { AppState, history } from 'src';
import {
  ContractEmailComponent,
  ContractEmailComponentProperties
} from 'src/contract/_components/contract-email/_components/contract-email.component';
import {
  getContractEmailList,
  saveContractEmailSelections
} from 'src/contract/_components/contract-email/contract-email.actions';
import { ContractEmailForm, EmailNotificationViewModel } from '@models/Contract';
import { RouteDefinitions, getRoute } from '@common/route-definitions';
import { actions } from 'react-redux-form';
import FormNames from '@constants/FormNames.enum';
import { toggleModal } from '@common/components/common.actions';

function mapStateToProps(state: AppState): Partial<ContractEmailComponentProperties> {
  return {
    contractEmailList: state.contract.contractEmail.contractEmailList
  };
}

function mapDispatchToProps(
  dispatch: Dispatch<AppState>,
  ownProps: ContractEmailComponentProperties
): Partial<ContractEmailComponentProperties> {
  return {
    getContractEmailList: async (contractId: number) => {
      await dispatch(getContractEmailList(contractId));
      return Promise.resolve();
    },
    setContractEmails: (emailList: Array<EmailNotificationViewModel>) => {
      emailList.forEach((value, index) => {
        dispatch(actions.change(FormNames.ContractEmailForm + '.contractEmailList[' + index + '].email', true));
      });
    },
    saveContractEmailSelections: async (contractId: number, formData: ContractEmailForm, isModal?: boolean) => {
      await dispatch(saveContractEmailSelections(contractId, formData)).then(() => {
        if (!isModal) {
          history.push(getRoute(RouteDefinitions.contract.Details, { id: +contractId }));
        } else {
          if (ownProps.saveCallback) {
            dispatch(ownProps.saveCallback);
          } else {
            dispatch(toggleModal());
          }
        }
      });
    }
  };
}

export const ContractEmail = connect(
  mapStateToProps,
  mapDispatchToProps
)(ContractEmailComponent);



// WEBPACK FOOTER //
// ./src/contract/_components/contract-email/_components/contract-email.container.ts